import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import ProtegoSymbol from './ProtegoSymbol';

const Header = ({ onContactClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header-fixed">
      <div className="header-container">
        <div className="logo">
          <ProtegoSymbol size={32} color="#C9A961" strokeWidth={1.2} />
          <span className="logo-text">ПРОТЕГО</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          <button onClick={() => scrollToSection('about')} className="nav-link">Про нас</button>
          <button onClick={() => scrollToSection('practice')} className="nav-link">Практика</button>
          <button onClick={() => scrollToSection('news')} className="nav-link">Новини</button>
          <button onClick={() => scrollToSection('values')} className="nav-link">Цінності</button>
          <button onClick={() => scrollToSection('contacts')} className="nav-link">Контакти</button>
        </nav>

        <div className="header-cta-desktop">
          <Button onClick={onContactClick} className="btn-primary">
            Зв'язатися
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <nav className="nav-mobile">
          <button onClick={() => scrollToSection('about')} className="nav-link-mobile">Про нас</button>
          <button onClick={() => scrollToSection('practice')} className="nav-link-mobile">Практика</button>
          <button onClick={() => scrollToSection('news')} className="nav-link-mobile">Новини</button>
          <button onClick={() => scrollToSection('values')} className="nav-link-mobile">Цінності</button>
          <button onClick={() => scrollToSection('contacts')} className="nav-link-mobile">Контакти</button>
          <Button onClick={onContactClick} className="btn-primary" style={{width: '100%', marginTop: '1rem'}}>
            Зв'язатися
          </Button>
        </nav>
      )}
    </header>
  );
};

export default Header;
